// Domain types for the Admin Questionnaires MSPA.

// Edit-page tab keys. Local state only — no routing (see spec).
export type QuestionnaireEditTab =
  | "survey"
  | "questions"
  | "lookups"
  | "calculations"
  | "recommendations";

export const QUESTIONNAIRE_EDIT_TABS: {
  key: QuestionnaireEditTab;
  label: string;
}[] = [
  { key: "survey", label: "Survey" },
  { key: "questions", label: "Questions" },
  { key: "lookups", label: "Lookups" },
  { key: "calculations", label: "Calculations" },
  { key: "recommendations", label: "Recommendations" },
];

// A row in the questionnaires list table.
export interface Questionnaire {
  id: string;
  name: string;
  published: boolean;
  tagList: string[];
}

// Controlled values for the Survey (questionnaire) form.
export interface SurveyFormValues {
  name: string;
  published: boolean;
  introduction: string;
  thankYou: string;
  redirect: boolean; // UI-only: when true, completionUrl is sent
  completionUrl: string;
  tagList: string[];
  teamIds: string[];
}

export const emptySurveyForm: SurveyFormValues = {
  name: "",
  published: false,
  introduction: "",
  thankYou: "",
  redirect: false,
  completionUrl: "",
  tagList: [],
  teamIds: [],
};

// Minimal values for the New (create) page.
export interface NewQuestionnaireValues {
  name: string;
  published: boolean;
}
